export default (qty) => ({
    quantity: qty,
    increment() {
        this.quantity++;
    },
    decrement() {
        this.quantity > 0 ? this.quantity-- : (this.quantity = 0);
    },
});
